import { HttpClient } from '@angular/common/http';
import { inject, Injectable } from '@angular/core';
import { BehaviorSubject, catchError, map, of, switchMap, tap } from 'rxjs';
import { InsertPost, Post } from '../dto';
import { api } from '@shared/api/api.contract';
import { buildUrl } from '@shared/api/build-url';


@Injectable({ providedIn: 'root' })
export class PostsService {
  private http = inject(HttpClient);

  // React Query invalidateQueries karşılığı
  private refresh$ = new BehaviorSubject<void>(undefined);

  getPosts() {
    return this.refresh$.pipe(
      switchMap(() =>
        this.http.get<Post[]>(api.posts.list.path, { 
          withCredentials: true
        })
      )
    );
  }

  getPost(slug: string) {
    if (!slug) return of(null);

    const url = buildUrl(api.posts.get.path, { slug });

    return this.http.get<Post>(url, {
      withCredentials: true,
      observe: 'response'
    }).pipe(
      map(res => res.body),
      catchError(err => {
        if (err.status === 404) return of(null);
        throw err;
      })
    );
  }

  createPost(data: InsertPost) {
    const validated = api.posts.create.input.parse(data);

    return this.http.post<Post>(
      api.posts.create.path,
      validated,
      {
        withCredentials: true
      }
    ).pipe(
      tap(() => this.refresh$.next())
    );
  }
}
